const EVENT_START_DATE_TIME = 'start_date_time'
const EVENT_END_DATE_TIME = 'end_date_time'
const DEFAULT_EVENT_PAGE_SIZE = 10
const DEFAULT_EVENT_PAGE_NO = 1
const DEFAULT_EVENT_LIST = []
const DEFAULT_SYSTEM_PAGE_SIZE = 10
const DEFAULT_SYSTEM_PAGE_NO = 1
const DEFAULT_SYSTEM_SORT_BY = 'site_id'
const DEFAULT_SYSTEM_LIST = []
const DEFAULT_EVENT_TIMELINE = '1'
const EVENT_TIMELINE_BACKWARD = '-1'
const EVENT_TIMELINE_FORWARD = '1'
const SYSTEM_ENROLLED = '1'
const SYSTEM_UNENROLLED = '0'
const ENROLLED = 'ENROLLED'
const UNENROLLED = 'UNENROLLED'
const systemsTableHeadings = (committed_power_in_program, classes) => ([
  {
    id: 'siteId',
    header: 'SITE ID',
    isLink: true,
  },
  {
    id: 'systemName',
    header: 'SYSTEM NAME',
  },
  {
    id: 'batteryCapacity',
    header: 'TOTAL ENERGY (kWh)',
    className: classes.textAlignCenter
  },
  {
    id: 'batteryPower',
    header: committed_power_in_program ? 'COMMITTED POWER (kW)' : 'TOTAL POWER (kW)',
    className: classes.textAlignCenter
  },
])

const eventsTableHeadings = [
  {
    id: 'eventName',
    header: 'EVENT NAME',
    isLink: true,
    isActive: true,
  },
  {
    id: 'eventType',
    header: 'EVENT TYPE',
  },
  {
    id: 'eventSubType',
    header: 'EVENT SUB TYPE',
  },
  {
    id: 'eventStartTime',
    header: 'EVENT START TIME',
  },
  {
    id: 'eventDuration',
    header: 'EVENT DURATION',
  },
]

const SYSTEMSENROLLED = 'Systems Enrolled'
const SYSTEMSUNENROLLED = 'Systems Unenrolled'

const getSystemToggleOptions = () => [
  {
    label: 'Systems Enrolled',
    id: SYSTEMSENROLLED,
  },
  {
    label: 'Systems Unenrolled',
    id: SYSTEMSUNENROLLED,
  },
]

const ONGOINGANDUPCOMING = 'Ongoing&Upcoming'
const HISTORY = 'history'
const getEventToggleOptions = () => [
  {
    label: 'Ongoing & Upcoming',
    id: ONGOINGANDUPCOMING,
  },
  {
    label: 'History',
    id: HISTORY,
  },
]

const EVENT_TYPE = {
  BATTERY_DISCHARGE: 'Discharge Event',
  BATTERY_CHARGE: 'Charge Event',
  IDLE: 'Idle Event'
}

const EVENT_SUBTYPE = {
  Discharge_To_Load: 'Discharge to Load',
  Discharge_To_Load_Grid: 'Discharge to Load and Grid',
  Discharge_To_NetLoad: 'Discharge to Net Load',
  Charge_From_PV: 'Charge From PV',
  Charge_From_NetPV: 'Charge From Net PV',
  Charge_From_PV_Grid: 'Charge From PV and Grid',
  Idle: 'Idle'
}

const registeredSitesTableHeadings = [
    { id: 'srNo', header: 'Sr No' },
    { id: 'siteId', header: 'Site ID' },
    { id: 'name', header: 'Name' },
    { id: 'lfdi', header: 'LFDI' },
    { id: 'nmi', header: 'NMI' },
    { id: 'status', header: 'Status' },
    { id: 'actions', header: 'Actions' }
]

export {
  systemsTableHeadings,
  eventsTableHeadings,
  ONGOINGANDUPCOMING,
  HISTORY,
  SYSTEMSENROLLED,
  SYSTEMSUNENROLLED,
  getEventToggleOptions,
  getSystemToggleOptions,
  EVENT_START_DATE_TIME,
  EVENT_END_DATE_TIME,
  DEFAULT_EVENT_PAGE_SIZE,
  DEFAULT_EVENT_PAGE_NO,
  DEFAULT_SYSTEM_PAGE_SIZE,
  DEFAULT_SYSTEM_PAGE_NO,
  DEFAULT_EVENT_LIST,
  DEFAULT_SYSTEM_LIST,
  DEFAULT_SYSTEM_SORT_BY,
  DEFAULT_EVENT_TIMELINE,
  EVENT_TIMELINE_BACKWARD,
  EVENT_TIMELINE_FORWARD,
  SYSTEM_ENROLLED,
  SYSTEM_UNENROLLED,
  ENROLLED,
  UNENROLLED,
  EVENT_TYPE,
  EVENT_SUBTYPE,
  registeredSitesTableHeadings
}